const N = (t) => {
  let r = [];
  return Array.from(t.querySelectorAll("title")).forEach((n) => {
    const i = document.head.querySelector("title");
    i ? document.head.replaceChild(n, i) : document.head.append(n);
  }), Array.from(t.querySelectorAll("meta")).forEach((n) => {
    const i = n.getAttribute("name"), s = n.getAttribute("property");
    if (i || s) {
      const o = document.head.querySelectorAll(`meta[name="${i}"]`), u = document.head.querySelectorAll(`meta[property="${s}"]`);
      o != null && o[0] ? document.head.replaceChild(n, o[0]) : u != null && u[0] ? document.head.replaceChild(n, u[0]) : document.head.append(n);
    } else
      document.head.append(n);
  }), Array.from(t.querySelectorAll("link, style")).forEach((n) => {
    const i = (s) => new Promise((o) => {
      if (s instanceof HTMLLinkElement && s.href && !s.onload && s.rel == "stylesheet") {
        const u = document.createElement("link");
        Array.from(s.attributes).forEach((f) => {
          u.setAttribute(f.name, f.value);
        }), u.onload = () => o(!0), u.onerror = () => {
          console.error(`Failed to load CSS file: ${u.href}`), o(!1);
        }, document.head.append(u), s.remove();
      } else
        document.head.append(s), o(!0);
    });
    r.push(() => i(n));
  }), J(r).then(() => {
  }).catch((n) => console.error(n));
}, M = async (t, r) => {
  var n = Q(t), i = n.filter((o) => o.hasAttribute("priority"));
  console.debug("Priority Scripts:", i);
  var s = n.filter((o) => !o.hasAttribute("priority"));
  console.debug("Unsorted Scripts:", s);
  for (const o of i)
    await new Promise((u) => {
      x(o, r, u);
    });
  s.forEach((o) => {
    x(o, r);
  });
}, x = (t, r, n) => {
  var i, s;
  if ((i = t.innerHTML) != null && i.includes("document.write")) {
    console.error("Error: Unable to reprocess this script tag as it contains a 'document.write()' call.", t);
    return;
  }
  try {
    const o = document.createElement("script");
    Array.from(t.attributes).forEach((f) => {
      o.setAttribute(f.name, f.value);
    });
    const u = document.createTextNode(t.innerHTML);
    o.appendChild(u), typeof n == "function" && (o.onload = () => n()), t.parentNode ? (s = t.parentNode) == null || s.replaceChild(o, t) : document.body.replaceChild(o, t), typeof r == "function" && (r == null || r(t, o));
  } catch (o) {
    console.error("Error: Unable to reprocess this script tag.", o, t);
  }
}, J = (t) => t.reduce((r, n) => r.then(
  (i) => n().then((s) => [...i, s])
), Promise.resolve([])), Q = (t) => Array.from(t.querySelectorAll("script")).sort((i, s) => {
  const o = parseInt(i.getAttribute("priority") ?? "Infinity"), u = parseInt(s.getAttribute("priority") ?? "Infinity");
  return o - u;
}), j = (t) => {
  const i = decodeURIComponent(document.cookie).split("; ").find((s) => s.startsWith(`${t}=`));
  return i == null ? void 0 : i.split(`${t}=`)[1];
}, H = "x-d-token", B = () => j("reese84"), W = (t) => {
  var r;
  return (t == null ? void 0 : t.status) == 405 || (t == null ? void 0 : t.status) == 0 || typeof (t == null ? void 0 : t.data) == "string" && ((r = t == null ? void 0 : t.data) == null ? void 0 : r.includes("<title>Pardon Our Interruption</title>"));
}, q = (t) => {
  var r;
  if (t) {
    let n = document.getElementById("imperva-challenge");
    n && ((r = n.parentNode) == null || r.removeChild(n)), n = document.createElement("div"), n.id = "imperva-challenge";
    const i = {
      color: "#000",
      background: "#fff",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zindex: 999999,
      overflow: "hidden"
    };
    Object.assign(n.style, i), n.innerHTML = t, document.body.appendChild(n), M(n);
  } else
    alert("An error occured while loading. Please refresh your page and try again."), console.error("No challenge response to render.");
}, T = (t) => {
  let r = !1;
  if ((t != null && t.data || t != null && t.status) && (r = !0), !t || r && W(t)) {
    q(t == null ? void 0 : t.data);
    return;
  }
  return t;
}, Z = {
  tokenHeaderName: H,
  getToken: B,
  isChallengeRequest: W,
  renderChallengeResponse: q,
  analyzeResponse: T
}, X = {
  enabled: !1,
  debug: !1,
  forceBeta: !1,
  forceImpervaScript: !1,
  betaCookieName: "SH_UseBetaSite",
  useLegacyRoutes: !0,
  legacySlug: "/inventory/",
  elementId: "inventory-wrapper",
  errorRoute: "/notfound.html"
}, ee = (t = {}) => {
  const r = { ...X, ...t }, n = "/HostedBilling/Invoice/", i = (e = !0) => r.enabled = e === !0, s = () => o().isInternal ? "DEVELOPMENT" : B(), o = () => {
    const e = window.location.hostname, a = {
      hostName: e,
      isInternal: !1,
      subdomain: L() ? "beta." : "www."
    }, h = ["sandhillsdemo4", "sandhillsdemo11"];
    return e.endsWith(".hdev") || e.endsWith(".hdsdev") || e.endsWith(".wpdev") ? (a.isInternal = !0, h.some((p) => e.includes(p)) && (a.subdomain = `dev1.${L() ? "beta." : ""}`)) : (e.endsWith(".hstg") || e.endsWith(".hdsstg") || e.endsWith(".wpstg")) && (a.isInternal = !0, h.some((p) => e.includes(p)) && (a.subdomain = `stg1.${L() ? "beta." : ""}`)), a;
  }, u = () => window.location.hostname.startsWith("stg."), f = () => o().subdomain, L = () => {
    const e = j(r.betaCookieName);
    return (e == null ? void 0 : e.toLowerCase()) === "true" || e == "1";
  }, G = () => `https://${f()}sandhillsinventory.com`, U = () => {
    let e = "";
    const a = decodeURIComponent(window.location.search);
    return a.startsWith("?/") ? e = a.slice(1) : a.startsWith("?Payment") ? e = n : (window.location.pathname.startsWith("/listing") || window.location.pathname.startsWith("/parts") || window.location.pathname.startsWith("/job-listings")) && (e = `${window.location.pathname}${window.location.search}`), e;
  }, C = (e) => r.useLegacyRoutes ? `${r.legacySlug}?${e}` : e, F = (e) => {
    const a = e ?? U();
    if (!a.startsWith("/"))
      return console.error(`Invalid URL: ${a}`), window.location.href = r.errorRoute, new URL(r.errorRoute);
    const h = a.includes("?") ? "&" : "?";
    return new URL(`${G()}${a}${h}${D()}`);
  }, D = () => `exload=1&hostedDomain=${window.location.hostname}`, O = () => {
    const e = document.getElementById(r.elementId);
    return e || console.error(`Unable to find element on the page with id: ${r.elementId}`), e;
  }, V = (e) => {
    if (!r.enabled)
      throw new Error("SandhillsHostedSites is not enabled. Please call the .enable() method.");
    const a = F(e || void 0), h = O();
    if (h) {
      h.style.display = "none";
      const p = new Headers(), b = s();
      b && p.append(H, b), w("InvResponseStarted"), d(""), d("****** Loading Inventory ******"), fetch(a.href, {
        mode: "cors",
        headers: p
      }).then(async (m) => {
        var c;
        d(`Response Time: ${(c = v("InvResponseTime", "InvResponseStarted")) == null ? void 0 : c.duration}ms`);
        var g = await m.text();
        const I = T({ status: m.status, data: g });
        return {
          htmlResponse: (I && g) ?? "",
          fetchResponse: m
        };
      }).then(async (m) => {
        var g, I, R, c, S;
        if (m)
          if (m.htmlResponse.startsWith("/"))
            window.location.href = C(m.htmlResponse);
          else {
            if (w("InvDocStarted"), w("InvHtmlParseStarted"), h.innerHTML = m.htmlResponse, d(`Parse Html Time: ${(g = v("InvHtmlParseTime", "InvHtmlParseStarted")) == null ? void 0 : g.duration}ms`), w("InvMetaParseStarted"), await N(h), d(`Parse Meta Time: ${(I = v("InvMetaParseTime", "InvMetaParseStarted")) == null ? void 0 : I.duration}ms`), w("InvScriptParseStarted"), E("Script Details"), await M(h, (l, y) => {
              d(`   - Script: ${l.hasAttribute("src") ? l.getAttribute("src") : l.innerText.substring(0, 100)}`), d(`     - Executed At: ${(/* @__PURE__ */ new Date()).toISOString()}`, { oldEl: l, newEl: y });
            }), k(), d(`Parse Scripts Time: ${(R = v("InvScriptParseTime", "InvScriptParseStarted")) == null ? void 0 : R.duration}ms`), !a.href.includes(n)) {
              const l = a.href !== m.fetchResponse.url;
              let y = C(e || U());
              if (l) {
                d(`Redirected to: ${m.fetchResponse.url}`);
                const P = new URL(m.fetchResponse.url);
                let $ = P.pathname + P.search;
                const _ = $.includes("?") ? "&" : "?";
                $ = $.replace(`${_}${D()}`, ""), y = C($);
              }
              history.pushState(a.search, "", y);
            }
            h.style.display = "block", (c = document.getElementById("lds")) == null || c.remove(), d(`Doc Time: ${(S = v("InvDocTime", "InvDocStarted")) == null ? void 0 : S.duration}ms`), setTimeout(function() {
              if (window.MediaController) {
                d("** Temp patch for Media Control Window Load events: v1"), window.MediaController.Instances.loadComplete = !0, d(`Media Controller Instances: ${window.MediaController.Instances.length}`);
                for (var l = 0, y = window.MediaController.Instances.length; l < y; l++)
                  d(`Adjusting Media Controller Index: ${l}`), window.MediaController.Instances[l].thumbnails.alignThumbStrip(), window.MediaController.Instances[l].currentItem.loadRegImg();
              }
            }, 500);
          }
      }).catch(() => {
        T();
      });
    }
  }, z = () => {
    if (!r.enabled)
      throw new Error("SandhillsHostedSites is not enabled. Please call the .enable() method.");
    const e = new Headers(), a = s();
    a && e.append(H, a), w("LayoutResponseStarted"), d("****** Loading Layout ******");
    const h = `/InventoryLayout.htm${window.location.search}`;
    fetch(h, {
      headers: e
    }).then(async (p) => {
      var g;
      d(`Response Time: ${(g = v("LayoutResponseTime", "LayoutResponseStarted")) == null ? void 0 : g.duration}ms`);
      var b = await p.text();
      const m = T({ status: p.status, data: b });
      return m && b;
    }).then(async (p) => {
      var b, m, g, I;
      if (p) {
        const R = new URLSearchParams(window.location.search);
        w("LayoutHtmlReplacementStarted");
        let c = p;
        c = c.replace("##TITLE##", R.get("title") ?? ""), c = c.replace("<!--##REPLACE##-->", `${K()}<div id="inventory-wrapper"></div>`), c = c.replace("</head>", "<!-- Google Tag Manager --><script>(function(w, d, s, l, i){w[l]=w[l] || []; w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l !='dataLayer' ? '&l=' + l : ''; j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);})(window, document, 'script', 'dataLayer', 'GTM-N6K7FFV');<\/script><!-- End Google Tag Manager --> </head>"), c = c.replace("<body>", "<body> <!-- Google Tag Manager (noscript) --><noscript> <iframe src='https://www.googletagmanager.com/ns.html?id=GTM-N6K7FFV' height='0' width='0' style='display: none; visibility: hidden'></iframe></noscript><!-- End Google Tag Manager (noscript) -->"), c = c.replace(/(<body[^>]*>[\s\S]*?<\/body>)/gi, (l) => l.replace(/<script\b[^>]*\bsrc="[^"]*"[^>]*>/gi, (y) => y.replace(/<script(.*?)>/, '<script$1 priority="3">'))), c = c.replace(/(<body[^>]*>)([\s\S]*?)(<script.*?>)/, (l, y, P, $) => `${y}${A()}${P}${$}`), c.includes(A()) || (c = c.replace(/(<\/body>)/, `${A()}$1`)), c = c.replace("</body>", "</body> <!-- Loaded from [sandhills-imperva-ajax > loadLayout] (v0.1.28-beta) -->"), d(`Html Replacement Time: ${(b = v("LayoutHtmlReplacementTime", "LayoutHtmlReplacementStarted")) == null ? void 0 : b.duration}ms`);
        const S = document.querySelector("html");
        S && (w("LayoutDocStarted"), S.style.display = "none", S.innerHTML = c, w("LayoutMetaParseStarted"), await N(S), d(`Parse Meta Time: ${(m = v("LayoutMetaParseTime", "LayoutMetaParseStarted")) == null ? void 0 : m.duration}ms`), S.style.display = "", w("LayoutScriptParseStarted"), E("Script Details"), await M(S, (l, y) => {
          d(`   - Script: ${l.hasAttribute("src") ? l.getAttribute("src") : l.innerText.substring(0, 100)}`), d(`     - Executed At: ${(/* @__PURE__ */ new Date()).toISOString()}`, { oldEl: l, newEl: y });
        }), k(), d(`Parse Scripts Time: ${(g = v("LayoutScriptParseTime", "LayoutScriptParseStarted")) == null ? void 0 : g.duration}ms`), d(`Doc Time: ${(I = v("LayoutDocTime", "LayoutDocStarted")) == null ? void 0 : I.duration}ms`));
      }
    }).catch(() => {
      T();
    });
  }, A = () => {
    let e = "";
    return (r.forceImpervaScript && !o().isInternal || u()) && (e += `<script src='https://${f()}sandhillsinventory.com/6657193977244c13' priority='0'><\/script>`), e += `<script src='${r.relativeResourcePath}js/sandhills-imperva-ajax.umd.js?v=0.1.28-beta'><\/script>`, e += "<!-- Need for HS to have access to jQuery -->", e += `<script src='https://${f()}sandhillsinventory.com/bundles/common?v=NoCache' priority='1'><\/script>`, e += `<script src='https://${f()}sandhillsinventory.com/bundles/react?v=NoCache' priority='2'><\/script>`, e += "<script>", e += " setTimeout(() => {", e += `   window.sandhillsHostedSites = window.sandhillsHostedSites ?? SandhillsImpervaAjax.HostedSites(${JSON.stringify(t)});`, e += "   window.sandhillsHostedSites.loadInventory();", e += " }, 500);", e += "<\/script>", e;
  }, K = () => {
    let e = `<link rel="stylesheet" type="text/css" href="${r.relativeResourcePath}css/sandhills-imperva-ajax.css?v=0.1.28-beta">`;
    return e += '<div id="lds" class="lds">', e += '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>', e += '<div class="lds-label">Loading Inventory...</div>', e += "</div>", e;
  }, E = (e) => {
    r.debug && console.groupCollapsed(e);
  }, k = () => {
    r.debug && console.groupEnd();
  }, d = (e, ...a) => {
    r.debug && console.debug(e, ...a);
  }, w = (e) => r.debug ? window.performance.mark(e) : void 0, v = (e, a) => r.debug ? window.performance.measure(e, a) : void 0;
  return !L() && r.forceBeta && (document.cookie = `${r.betaCookieName}=true;path=/;sameSite=LAX;Secure;`), {
    enable: i,
    loadInventory: V,
    loadLayout: z,
    analyzeResponse: T
  };
};
export {
  ee as HostedSites,
  Z as Imperva
};
